import { render, staticRenderFns } from "./dailyWork.vue?vue&type=template&id=5f23b331&scoped=true"
import script from "./dailyWork.vue?vue&type=script&lang=js"
export * from "./dailyWork.vue?vue&type=script&lang=js"
import style0 from "./dailyWork.vue?vue&type=style&index=0&id=5f23b331&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f23b331",
  null
  
)

export default component.exports